import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "redux/AxiosClient";

export const getContractConvertChartDataAsync = createAsyncThunk(
  "mis/getContractConvertChartData",
  async (payload, toolkit) => {
    return await AxiosClient(
      "POST",
      `/mis/get-contract-pie-chart-data`,
      payload,
      toolkit
    );
  }
);
